// Community Deposit Management APIs

/**
 * @function ApiClient#SaveDepositPackage
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} depositData
 * @param {any} image
 * @param {any} options = {}
 */
export async function SaveDepositPackage(cid, depositData, image, options = {}) {
  const formData = new FormData();

  formData.set("Data", JSON.stringify(depositData));
  if (image) formData.set("Image", image, "webcam.jpg");

  return await this._post(`/community/${cid}/deposit`, formData, options);
}

/**
 * @function ApiClient#UpdateDepositPackage
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.User
 * @param {any} params.Package
 * @param {any} params.Status
 * @param {any} params.CheckMethod
 * @param {any} params.DeviceDBID
 * @param {any} params.CardUID
 * @param {any} params.CheckPS
 * @param {any} params.Image
 * @param {any} options = {}
 */
export async function UpdateDepositPackage(cid, { User, Package, Status, CheckMethod, DeviceDBID, CardUID, CheckPS, Image }, options = {}) {
  const formData = new FormData();
  if (User) formData.set("User", User);
  formData.set("Package", Package);
  formData.set("Status", Status);
  formData.set("CheckMethod", CheckMethod);
  if (DeviceDBID) formData.set("DeviceDBID", DeviceDBID);
  if (CardUID) formData.set("CardUID", CardUID);
  if (CheckPS) formData.set("CheckPS", CheckPS);
  if (Image) formData.set("Image", Image, "webcam.jpg");

  return await this._put(`/community/${cid}/deposit`, formData, options);
}

// Deposit Place Management APIs

/**
 * @function ApiClient#GetDepositPlaceList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetDepositPlaceList(cid, options = {}) {
  return await this._get(`/community/${cid}/deposit_place_list`, options);
}

/**
 * @function ApiClient#AddDepositPlace
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} placeName
 * @param {any} options = {}
 */
export async function AddDepositPlace(cid, placeName, options = {}) {
  return await this._post(`/community/${cid}/deposit_place?p=${placeName}`, null, options);
}

/**
 * @function ApiClient#UpdateDepositPlace
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} places
 * @param {any} options = {}
 */
export async function UpdateDepositPlace(cid, places, options = {}) {
  return await this._put(`/community/${cid}/deposit_place`, places, options);
}

/**
 * @function ApiClient#DeleteDepositPlace
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} placeName
 * @param {any} options = {}
 */
export async function DeleteDepositPlace(cid, placeName, options = {}) {
  return await this._delete(`/community/${cid}/deposit_place?p=${placeName}`, options);
}

// Deposit Type Management APIs

/**
 * @function ApiClient#GetDepositTypeList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} page = 1
 * @param {any} perPage = 100
 * @param {any} sortBy = "Sort"
 * @param {any} sortOrder = 1
 * @param {any} options = {}
 */
export async function GetDepositTypeList(cid, page = 1, perPage = 100, sortBy = "Sort", sortOrder = 1, options = {}) {
  return await this._get(`/community/${cid}/deposit_type_list?p=${page}&pp=${perPage}&sb=${sortBy}&so=${sortOrder}`, options);
}

/**
 * @function ApiClient#GetDepositType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function GetDepositType(cid, id, options = {}) {
  return await this._get(`/community/${cid}/deposit_type/${id}`, options);
}

/**
 * @function ApiClient#AddDepositType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddDepositType(cid, data, options = {}) {
  return await this._post(`/community/${cid}/deposit_type`, data, options);
}

/**
 * @function ApiClient#UpdateDepositType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateDepositType(cid, id, data, options = {}) {
  return await this._put(`/community/${cid}/deposit_type/${id}`, data, options);
}

/**
 * @function ApiClient#DeleteDepositType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function DeleteDepositType(cid, id, options = {}) {
  return await this._delete(`/community/${cid}/deposit_type/${id}`, options);
}
